export const API = {
  list: "/api/software.php",
  upload: "/api/upload.php",
  delete: "/api/delete.php",
};

export async function fetchJson(url, options = {}) {
  const response = await fetch(url, options);
  const contentType = response.headers.get("content-type") || "";

  if (!contentType.includes("application/json")) {
    const error = new Error("API_UNAVAILABLE");
    error.isApiUnavailable = true;
    throw error;
  }

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.error || "İstek başarısız oldu.");
  }

  return data;
}

export async function fetchSoftwareList() {
  try {
    return await fetchJson(API.list);
  } catch (error) {
    if (!error.isApiUnavailable) {
      throw error;
    }

    const response = await fetch("/data/software.json");
    if (!response.ok) {
      throw new Error("Yazılım listesi yüklenemedi.");
    }

    return response.json();
  }
}

export function getApiErrorMessage(error) {
  if (error.isApiUnavailable) {
    return "API yanıt vermedi. Hosting'de PHP etkin olduğundan ve api klasörünün yüklendiğinden emin olun.";
  }
  return error.message;
}
